import React, { useMemo } from "react";
import GraphicStands from "components/graphic-stand";
import GraphicPacking from "components/graphic-packing";
import { Localize } from "components/service";
import { useBreadCrumbs } from "components/use-hooks";



const GraphicStandOverviewSubPage = React.memo(({ graphicPacking, graphicStand, history }) => {


    const baseUrl = GraphicPacking.Const.basePath;
    const packingId = graphicPacking?.id || '';
    const standId = graphicStand?.id;

    const breadcrumbs = useMemo(() => [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Graphic_Commissioning" }).props.children,
            path: baseUrl
        },
        {
            label: graphicPacking?.title || '',
            path: `${ baseUrl }/${ packingId }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_GraphicPackedList" }).props.children,
            path: `${ baseUrl }/${ packingId }/packed-list`
        },
        {
            label: graphicStand?.exhibitor || Localize({ children: "BREADCRUMBS.Label_Create" }).props.children,
            path: `${ baseUrl }/${ packingId }/stands/${ standId || 'create' }`
        }
    ], [ baseUrl, packingId, standId, graphicPacking?.title, graphicStand?.exhibitor ]);

    useBreadCrumbs(breadcrumbs);

    return (

        <div className="row-grid column-gap-60 col-lg-2">
            <div className="col-left">
                <GraphicStands.Forms.Edit graphicStand={ graphicStand } graphicList={ graphicPacking } history={ history } />
            </div>
            <div className="col-right">
            </div>
        </div>
    )
});


export default GraphicStandOverviewSubPage;
